var React = require('react');

function Overview (props) {
    return React.createElement("svg",props,[React.createElement("ellipse",{"cx":"21.25","cy":"8.75","rx":"7.5","ry":"7.5","fill":"#EEEEEE","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.0658 5.52632C9.21556 5.52632 8.52632 6.21556 8.52632 7.06579V21.4342C8.52632 22.2844 9.21556 22.9737 10.0658 22.9737H20.3289C21.1792 22.9737 21.8684 22.2844 21.8684 21.4342V11.5962C21.8684 11.4601 21.8144 11.3295 21.7181 11.2333L16.1614 5.67662C16.0652 5.58038 15.9347 5.52632 15.7986 5.52632H10.0658ZM7.5 7.06579C7.5 5.64874 8.64874 4.5 10.0658 4.5H15.7986C16.2069 4.5 16.5984 4.66219 16.8871 4.9509L22.4438 10.5076C22.7325 10.7963 22.8947 11.1879 22.8947 11.5962V21.4342C22.8947 22.8513 21.746 24 20.3289 24H10.0658C8.64874 24 7.5 22.8513 7.5 21.4342V7.06579Z","fill":"#121212","key":1})]);
}

Overview.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = Overview;

Overview.default = Overview;
